export const APPLICATION_ID = '741a3de2-a7f5-4135-a173-ae931c568780';
export const CLIENT_TOKEN = 'pub52e6d9cf3c0a4c70955ab57c937f5e7e';
export const APPLICATION_SERVICE_NAME = 'fieldview-web---digital-map-book-(dmb)';
